<div class="detalle-container">
    <!-- Sistema de pestañas manual -->
    <nav class="tabs-nav">
        <button 
            *ngFor="let tab of tabs" 
            (click)="selectedTab = tab.id"
            [class.active]="selectedTab === tab.id"
        >
            {{ tab.title }}
        </button>
    </nav>

    <!-- Contenido de pestañas -->
    <div class="tab-content">
        <!-- Descripción general -->
        <section *ngIf="selectedTab === 'descripcion'" class="tab-section">
            <div class="card">
                <h3>Descripción del trámite</h3>
                <p class="formatted-text">{{ actividad.descripcion }}</p>
                
                <h3>Requerimientos</h3>
                <p class="formatted-text">{{ actividad.requisitos }}</p>
            </div>
        </section>

        <!-- Documentación -->
        <section *ngIf="selectedTab === 'documentacion'" class="tab-section">
            <div class="card">
                <h3>Documentación requerida</h3>
                <ul>
                    <li><strong>{{ actividad.documentacionRequerida }}</strong></li>
                </ul>
                
                <h3>Detalle de la documentación</h3>
                <ul>
                    <li *ngFor="let doc of actividad.documentosEstadosSolicitar">
                        <strong>{{ doc.documento.nombre }}</strong>
                        <p>{{ doc.documento.descripcion }}</p>
                    </li>
                </ul>
            </div>
        </section>

        <!-- ¡Importante! -->
        <section *ngIf="selectedTab === 'importante'" class="tab-section">
            <div class="card">
                <h3>Información importante</h3>
                <ul>
                    <li><strong>{{ actividad.importante }}</strong></li>
                </ul>
            </div>
        </section>

        <!-- Finalizando -->
        <section *ngIf="selectedTab === 'finalizando'" class="tab-section">
            <div class="card">
                <h3>Al finalizar</h3>
                <ul>
                    <li><strong>{{ actividad.finalizando }}</strong></li>
                </ul>
            </div>
        </section>
    </div>
</div>